import { TypePolicies } from '@apollo/client';
import { relayStylePagination } from '@apollo/client/utilities';

// Merging policy for APIs using nodes field flattened API
// instead of standard relay style specification
const _defaultNodesPaginationMerge = (existing, incoming) => {
  const existingNodes = existing?.nodes || [];
  const incomingNodes = incoming.nodes;

  return {
    pageInfo: incoming.pageInfo,
    nodes: [...existingNodes, ...incomingNodes],
  };
};

// Generate a default policy for pagination merging
const createDefaultPolicy = (
  typename: string,
  field: string,
  keyArgs?: string[]
): TypePolicies => {
  return {
    [typename]: {
      fields: {
        [field]: relayStylePagination(keyArgs),
      },
    },
  };
};

const GET_PUBLISHED_FOLDERS = createDefaultPolicy(
  'GetPublishedFoldersPayload',
  'folders',
  ['parentFolderId', 'source', 'sortOrder', 'sortType']
);

const GET_LOOMS = createDefaultPolicy('GetLoomsPayload', 'videos', [
  'folderId',
  'source',
  'sortType',
  'sortOrder',
]);

export const typePolicies: TypePolicies = {
  ...GET_PUBLISHED_FOLDERS,
  ...GET_LOOMS,
  // Add additional type policies here
  // ...
};
